import React, { useEffect } from 'react';
import * as Sentry from "@sentry/react";
export default function GlobalContainers(_ref) {
  var appProps = _ref.appProps;
  var currentLocale = appProps.currentLocale,
    siteWideNotice = appProps.siteWideNotice,
    adminLoggedIn = appProps.adminLoggedIn,
    translations = appProps.translations;
  useEffect(function () {
    if (appProps.isProduction) {
      Sentry.init({
        dsn: appProps.sentryReactDsn,
        integrations: []
      });
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "top-banner-full-width-ajax-container"
  }), siteWideNotice && /*#__PURE__*/React.createElement("div", {
    className: "sitewide-notice flex-box items-center flex-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "notice-text"
  }, translations.locked_status_notice), /*#__PURE__*/React.createElement("div", {
    className: "button-wrapper flex-box content-end"
  }, /*#__PURE__*/React.createElement("a", {
    className: "button",
    href: "/admin/".concat(currentLocale)
  }, translations.access_admin))), adminLoggedIn && /*#__PURE__*/React.createElement("div", {
    className: "access-admin-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "floating-btn-wrapper flex-box flex-column items-center content-center"
  }, /*#__PURE__*/React.createElement("a", {
    className: "flex-box items-center content-center",
    href: "/admin/".concat(currentLocale),
    target: "_blank",
    rel: "nofollow noindex"
  }), /*#__PURE__*/React.createElement("div", {
    className: "access-admin"
  }, translations.access_admin))));
}